/**
 * src/lib/voice/karaoke.js — word-karaoke helpers (TICKET-073 Slice 1).
 *
 * Shared by BOTH the TTS timer (useStreamingTTS — counts words to pace the
 * highlight) and the renderer (TurnBubble — splits the reply into words). They
 * MUST use the same split rule or the highlight lands on the wrong word. Keep
 * this the single source of truth for "how the reply is tokenised into words".
 */

/**
 * Split text into display words on whitespace, dropping empties.
 * @param {string|null|undefined} text
 * @returns {string[]}
 */
export function splitWords(text) {
  if (text == null) return [];
  return String(text).split(/\s+/).filter(Boolean);
}

/**
 * Map a (seq, wordIndex) pair to a word index global to the whole reply, by
 * summing the word counts of every earlier seq. seqTexts may be a Map (the
 * hook's seq→text store) or a plain array. A missing/skipped seq counts as 0
 * words (its audio failed but its text is still on screen — keeps alignment).
 * @param {Map<number,string>|string[]} seqTexts
 * @param {number} seq
 * @param {number} wordIndex
 * @returns {number}
 */
export function globalWordIndex(seqTexts, seq, wordIndex) {
  const get = seqTexts instanceof Map
    ? (s) => seqTexts.get(s)
    : (s) => (Array.isArray(seqTexts) ? seqTexts[s] : undefined);
  let base = 0;
  for (let s = 0; s < seq; s += 1) {
    base += splitWords(get(s)).length;
  }
  return base + Math.max(0, wordIndex || 0);
}
